// extracted by mini-css-extract-plugin
export default {"Container":"ListProjects_Container__Xp746"};